export default class Data<T> {

    public static success<T>(value: T) {
        return new Data(value, false, null);
    }

    public static loading<T>() {
        return new Data<T>(null, true, null);
    }

    public static error<T>(error: any) {
        return new Data<T>(null, false, error);
    }

    private constructor(
        public readonly value: T | null,
        public readonly loading: boolean,
        public readonly error: any | null,
    ) { }

    public valueOr<F>(fallbackValue: F) {
        return this.value == null ? fallbackValue : this.value;
    }
}
